export default "__VITE_ASSET__BSOyDzgt__"